import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Vector } from "../svg/Vector.svg";
import ArrowForward from "@mui/icons-material/ArrowForward";

const pages = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About",
    path: "/about",
  },
  {
    title: "Services",
    data: [
      {
        title: "SaaS Services",
        path: "saas-service",
      },
      {
        title: "Business Intelligence",
        path: "business-intelligence",
      },
      {
        title: "Web & Mobile App Development",
        path: "app-development",
      },
    ],
  },
  {
    title: "How we work?",
    path: "/how-we-work",
  },
];

const MobileView = React.memo(() => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleNavigation = (path) => {
    if (path) {
      window.scrollTo(0, 0);
      navigate(path);
    }
  };

  return (
    <Box
      sx={{
        borderTop: `1px solid ${theme.palette.primary.gray}`,
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        height: "55vh",
      }}
    >
      <Box
        sx={{
          width: "85%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderBottom: `1px solid ${theme.palette.primary.gray}`,
            gap: 2,
            marginTop: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
          >
            <img
              src="images/footer/logo_ihc.png"
              alt="Header Logo"
              style={{ height: 26 }}
            />
            <Typography variant="h5" sx={{ fontSize: "16px" }}>
              InfinityHyperCloud
            </Typography>
          </Box>
          <Box
            sx={{
              gap: 2,
              display: "flex",
              flexDirection: "column",
              mb: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: "16px",
              }}
            >
              E-mail: info@infinityhypercloud.com
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Box
            sx={{
              mb: 4,
            }}
          >
            <Typography
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "16px",
                mb: 4,
                color: "#ffffffa3",
              }}
            >
              Company
            </Typography>
            {pages
              .filter((item) => item.title !== "Services")
              .map((item, index) => {
                return (
                  <Button
                    key={index}
                    sx={{
                      textTransform: "none",
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: 1,
                      color: "rgba(255,255,255,0.95)",
                      borderRadius: 1,
                      pb: 1.5,
                      pt: 1.5,
                      textAlign: "left",
                      "&:hover": {
                        borderColor: "rgba(255,255,255,0.75)",
                      },
                    }}
                    type="submit"
                    variant="outlined"
                    onClick={() => {
                      if (item.path) {
                        handleNavigation(item.path);
                      }
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: "16px",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <ArrowForward
                      alignSelf="flex-start"
                      sx={{
                        fontSize: 16,
                      }}
                    />
                  </Button>
                );
              })}
          </Box>
          <Box
            sx={{
              borderTop: `1px solid ${theme.palette.primary.gray}`,
              mb: 4,
            }}
          />
          {/* SERVICES */}
          <Box
            sx={{
              mb: 2,
            }}
          >
            {(() => {
              const services = pages.find((p) => p.title === "Services");
              if (!services || !Array.isArray(services.data)) return null;
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    mb: 4,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "16px",
                      mb: 4,
                      color: "#ffffffa3",
                    }}
                  >
                    Services
                  </Typography>

                  {services.data.map((child, childIndex) => {
                    return (
                      <Button
                        key={childIndex}
                        onClick={() =>
                          handleNavigation(`/services/${child.path}`)
                        }
                        sx={{
                          textTransform: "none",
                          display: "flex",
                          justifyContent: "flex-start",
                          gap: 1,
                          color: "rgba(255,255,255,0.95)",
                          borderRadius: 1,
                          pb: 1.5,
                          pt: 1.5,
                          textAlign: "left",
                          "&:hover": {
                            borderColor: "rgba(255,255,255,0.75)",
                          },
                        }}
                        type="submit"
                        variant="outlined"
                      >
                        <Typography
                          sx={{
                            fontFamily: "'Montserrat', sans-serif",
                            fontSize: "16px",
                          }}
                        >
                          {child.title}
                        </Typography>
                        <ArrowForward
                          alignSelf="flex-start"
                          sx={{
                            fontSize: 16,
                          }}
                        />
                      </Button>
                    );
                  })}
                </Box>
              );
            })()}
          </Box>
          <Box
            sx={{
              borderTop: `1px solid ${theme.palette.primary.gray}`,
              mb: 4,
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginBottom: 4,
            gap: 2,
          }}
        >
          {["LinkedIn", "fb", "X", "Instagram"].map((item, index) => (
            <img
              style={{ height: "30px", width: "30px", cursor: "pointer" }}
              src={`/images/footer/${item}.png`}
              alt={item}
              key={index}
            />
          ))}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 0.5,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: theme.palette.primary.white,
                opacity: "60%",
                textDecoration: "underline",
                textDecorationThickness: 1,
                textUnderlineOffset: 4,
                fontSize: {
                  xs: "0.6rem",
                  md: "0.8rem",
                },
              }}
            >
              © 2025 InfinityHyperCloud.
              <br />
              All rights reserved.
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                color: theme.palette.primary.white,
                opacity: "60%",
                textDecoration: "underline",
                textDecorationThickness: 1,
                textUnderlineOffset: 4,
                fontSize: {
                  xs: "0.6rem",
                  md: "0.8rem",
                },
              }}
            >
              Terms and Conditions
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                color: theme.palette.primary.white,
                opacity: "60%",
                textDecoration: "underline",
                textDecorationThickness: 1,
                textUnderlineOffset: 4,
                fontSize: {
                  xs: "0.6rem",
                  md: "0.8rem",
                },
              }}
            >
              Privacy Policy
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

const WebView = React.memo(() => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <Box
      sx={{
        borderTop: `1px solid ${theme.palette.primary.gray}`,
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        height: "55vh",
      }}
    >
      <Box
        sx={{
          width: "85%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: "80%",
            gap: 2,
          }}
        >
          <Box
            sx={{
              maxHeight: 170,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              <img
                src="images/footer/logo_ihc.png"
                alt="Header Logo"
                style={{ height: 55 }}
              />
              <Typography
                variant="h4"
                sx={{
                  fontSize: {
                    xs: "1.3rem",
                    lg: "1.5rem",
                  },
                }}
              >
                InfinityHyperCloud
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <MailOutlineIcon fontSize="small" />
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: "0.9rem", lg: "1rem" },
                }}
              >
                info@infinityhypercloud.com
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              maxHeight: 170,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: "#ffffffa3",
                fontSize: {
                  xs: "1.3rem",
                  lg: "1.5rem",
                },
              }}
            >
              Company
            </Typography>
            {pages
              .filter((page) =>
                ["Home", "About", "How we work?"].includes(page.title)
              )
              .map((page, index) => (
                <Typography
                  key={index}
                  variant="subtitle2"
                  sx={{
                    color: theme.palette.primary.white,
                    // opacity: "60%",
                    cursor: "pointer",
                    position: "relative",
                    "&:hover": {
                      opacity: 1,
                    },
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      left: "50%",
                      bottom: 0,
                      width: "0%",
                      height: "1px",
                      backgroundColor: theme.palette.primary.white,
                      transition:
                        "width 0.3s ease-in-out, left 0.3s ease-in-out",
                    },
                    "&:hover::after": {
                      width: "100%",
                      left: "0%",
                    },
                  }}
                  onClick={() => {
                    if (page.path) handleNavigation(page.path);
                  }}
                >
                  {page.title}
                </Typography>
              ))}
          </Box>
          <Box
            sx={{
              maxHeight: 170,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: "#ffffffa3",
                fontSize: {
                  xs: "1.3rem",
                  lg: "1.5rem",
                },
              }}
            >
              Services
            </Typography>
            {pages[2].data?.map((service, index) => (
              <Typography
                key={index}
                variant="subtitle2"
                sx={{
                  color: theme.palette.primary.white,
                  // opacity: "60%",
                  cursor: "pointer",
                  position: "relative",
                  "&:hover": {
                    opacity: 1,
                  },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: "50%",
                    bottom: 0,
                    width: "0%",
                    height: "1px",
                    backgroundColor: theme.palette.primary.white,
                    transition: "width 0.3s ease-in-out, left 0.3s ease-in",
                  },
                  "&:hover::after": {
                    width: "100%",
                    left: "0%",
                  },
                }}
                onClick={() => handleNavigation(`/services/${service.path}`)}
              >
                {service.title}
              </Typography>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignSelf: "flex-end",
              mb: 2,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
              {["LinkedIn", "fb", "X", "Instagram"].map((item, index) => (
                <img
                  style={{ height: "30px", width: "30px", cursor: "pointer" }}
                  src={`/images/footer/${item}.png`}
                  alt={item}
                  key={index}
                />
              ))}
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              borderTop: `1px solid ${theme.palette.primary.gray}`,
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: theme.palette.primary.white,
                opacity: "60%",
                textDecoration: "underline",
                textDecorationThickness: 1,
                textUnderlineOffset: 4,
              }}
            >
              © 2025 InfinityHyperCloud. All rights reserved.
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 10 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: theme.palette.primary.white,
                  opacity: "60%",
                  textDecoration: "underline",
                  textDecorationThickness: 1,
                  textUnderlineOffset: 4,
                }}
              >
                Terms and Conditions
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  color: theme.palette.primary.white,
                  opacity: "60%",
                  textDecoration: "underline",
                  textDecorationThickness: 1,
                  textUnderlineOffset: 4,
                }}
              >
                Privacy Policy
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

const Footer = () => {
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.up("md"));

  return isMdScreen ? <WebView /> : <MobileView />;
};

export default Footer;
